import { LinkProducer, NavigateFunction } from '@domain/app';

export const goToUrl = (url: string) => {
    window.location.href = `${url}`;
};

export const RESOURCE_PATH = '/kredittbank-kredittkort-betjening-web/rest/resource';

export const goToRoot = (navigate: NavigateFunction) => {
    return navigate('HOME_PAGE')();
};

export const getHomeUrl = (linkProducer: LinkProducer) => linkProducer('HOME_PAGE')();

export const getKredittbankenUrl = (url, card, account) =>
    url
        .replace(':accountId', account.accountId)
        .replace(':cardUri', `cid=${card?.id}%26ctype=CREDIT%26kontoid=${account.accountId}%26invalidate=true`);
